// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".new-message {\n  position: relative;\n}\n.new-message::after {\n  content: \" \";\n  width: 8px;\n  height: 8px;\n  background: #fe453d;\n  opacity: 1;\n  position: absolute;\n  border-radius: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
